export class BusEvent {
    public static ERROR = 'error';
    public static CLEAR_ERROR = 'clear-error';
    public static PAGE_CHANGE = 'page-change';
    
    public static CACHE_CHANGED = 'cache-changed';
}
